/**
 * Convert an HTTP(S) API URL or dev-proxy-relative path to a WebSocket URL.
 * In production, portals and API are on different hosts — chat must use the API host.
 */
export function resolveWebSocketUrl(resolvedHttpPath: string): string {
  if (resolvedHttpPath.startsWith('http://') || resolvedHttpPath.startsWith('https://')) {
    const u = new URL(resolvedHttpPath);
    u.protocol = u.protocol === 'https:' ? 'wss:' : 'ws:';
    return u.toString();
  }

  const protocol =
    typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const normalized = resolvedHttpPath.startsWith('/') ? resolvedHttpPath : `/${resolvedHttpPath}`;
  const host = typeof window !== 'undefined' ? window.location.host : 'localhost';
  return `${protocol}//${host}${normalized}`;
}
